import { render } from "./CreateBill.vue?vue&type=template&id=5036cc2d&scoped=true"
import script from "./CreateBill.vue?vue&type=script&lang=js"
export * from "./CreateBill.vue?vue&type=script&lang=js"

import "./CreateBill.vue?vue&type=style&index=0&id=5036cc2d&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5036cc2d"]])

export default __exports__